module.exports = __webpack_public_path__ + "img/1491697185.8015d55b.jpg";